"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_LINE_CATEGORY_RELATIONS = void 0;
// tslint:disable
exports.SERVICE_LINE_CATEGORY_RELATIONS = {
    UNKNOWN: {},
    HEALTH: {
        VETERINARIAN: {
            VACCINATIONS: {},
            GENERAL_CHECKUP: {},
            EMERGENCY_CARE: {},
            SURGICAL_CARE: {}
        },
        NUTRITION: {},
        PHARMACY_SERVICES: {},
        SPECIALIST_CARE: {
            SPECIALIST_SKIN_CARE: {},
            SPECIALIST_HAIR_CARE: {},
            SPECIALIST_EYE_CARE: {},
            SPECIALIST_DIGESTIVE_CARE: {},
            SPECIALIST_DENTAL_CARE: {}
        }
    },
    TRAINING_SERVICES: {
        BEHAVIORAL_TRAINING: {
            PUPPY_TRAINING: {},
            OBEDIENCE_I: {},
            FOUNDATION_SKILLS: {},
            SKILL_BUILDING: {},
            RELIABILITY: {},
            ADVANCED_SKILLS: {},
            EXPERT_SKILLS: {}
        },
        SPORT_TRAINING: {
            AGILITY_TRAINING: {},
            HUNTING_TRAINING: {},
            GUARD_TRAINING: {}
        }
    },
    GROOMING_SERVICES: {
        HAIR_GROOMING: {},
        NAIL_GROOMING: {},
        EAR: {},
        SKIN: {}
    },
    SOCIAL: {
        SOCIAL_SUPPORT: {
            DOG_WALKERS: {},
            DAYCARE: {},
            DOG_SITTER: {},
            BOARDING: {},
            DROP_IN_VISITS: {},
            ADOPTION_SERVICES: {}
        },
        SOCIAL_RECREATIONAL: {
            DOG_MEET_UP: {},
            DOG_PLAY_GROUPS: {
                ADULT_PLAY_GROUPS: {},
                PUPPY_PLAY_GROUPS: {}
            },
            RECREATIONAL_DOG_PARKS: {
                SMALL_DOG_PARKS: {},
                DOG_PARKS: {},
                PUPPY_PARKS: {}
            }
        }
    }
};
